const oopsibopThemeControllers = new WeakMap();

function initOopsibopTheme(root = document) {
  const menu = root.querySelector('[data-menu-toggle]');
  const nav = root.querySelector('[data-menu-nav]');
  if (menu && !menu.dataset.initialized) {
    const controller = new AbortController();
    menu.dataset.initialized = 'true';
    oopsibopThemeControllers.set(menu, controller);
    menu.addEventListener('click', () => {
      const open = menu.getAttribute('aria-expanded') === 'true';
      menu.setAttribute('aria-expanded', String(!open));
      nav?.classList.toggle('is-open', !open);
    }, { signal: controller.signal });
  }

  const hero = root.querySelector('[data-oopsibop-parallax]');
  if (hero && !hero.dataset.initialized) {
    hero.dataset.initialized = 'true';
    const controller = new AbortController();
    oopsibopThemeControllers.set(hero, controller);
    if (!matchMedia('(prefers-reduced-motion: reduce)').matches && !matchMedia('(pointer: coarse)').matches) {
      const art = hero.querySelector('.oo-hero-art');
      hero.addEventListener('pointermove', (event) => {
        const rect = hero.getBoundingClientRect();
        const x = (event.clientX - rect.left - rect.width / 2) / rect.width;
        const y = (event.clientY - rect.top - rect.height / 2) / rect.height;
        if (art) art.style.transform = `scale(1.035) translate(${x * -10}px,${y * -8}px)`;
      }, { signal: controller.signal });
      hero.addEventListener('pointerleave', () => { if (art) art.style.transform = ''; }, { signal: controller.signal });
    }
  }
}

function unloadOopsibopTheme(root) {
  root.querySelectorAll('[data-initialized]').forEach((node) => {
    oopsibopThemeControllers.get(node)?.abort();
    oopsibopThemeControllers.delete(node);
    delete node.dataset.initialized;
  });
}

document.addEventListener('DOMContentLoaded', () => initOopsibopTheme());
document.addEventListener('shopify:section:load', (event) => initOopsibopTheme(event.target));
document.addEventListener('shopify:section:unload', (event) => unloadOopsibopTheme(event.target));
